/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/


import React from 'react';
const FilterCategory = ({ title, filters, removeFilter }) => {

    console.log(filters, "jjjj")
    return (

        < div className="filter-category" >
            <h6 className="filter-category-title self-my-3">{title}</h6>
            <div className="filter-list">
                {filters?.map((ele, idx) => (
                    <span key={idx} className="filter-badge" onClick={(e) => removeFilter(ele)}>
                        ❌ {ele?.filter}-{ele?.value}
                    </span>
                ))}
            </div>
        </div >
    );
};

export default FilterCategory;
